<script>

    import { Loader } from '@googlemaps/js-api-loader'
    import { createEventDispatcher } from 'svelte'
    import { LatLngStore } from '../stores'

    const GOOGLE_MAPS_KEY = _CONST_.GOOGLE_MAPS_API_KEY
    const dispatch = createEventDispatcher()

    export let height = null;
    export let width = null;

    const loader = new Loader({
        apiKey: GOOGLE_MAPS_KEY,
        version: "weekly",
        libraries: ["places"]
    })

    let map = null
	let div = null

    loader
        .load()
		.then(() => {
			map = new google.maps.Map(div, {
				zoom: 12, 
				center: $LatLngStore || {
					lat: 19.4352,
					lng: -99.1412
				},
                styles: []
			})

            dispatch('load', map)
		})

</script>

<div id="map" bind:this={ div } style="min-height: {height}; min-width: {width};" ></div>